import React, { useEffect, useState } from 'react';
import Form from '../form/Form';
import OrganizationDetails from '../organization_details/OrganizationDetails';
import PaymentMethodsProvider from '../../../providers/PaymentMethods';

interface isPage {
  id: string;
  sessionToken: string;
  getStore: Function;
  store?: {
    app: string;
    trade_name?: string;
  }
}

const Content = ({
  id,
  sessionToken,
  getStore,
  store
}: isPage) => {
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setShowForm(!store?.trade_name)
  }, [store])

  if (showForm) {
    return (
      <Form
        id={id}
        isAssociated={!!store?.trade_name}
        getStore={getStore}
        sessionToken={sessionToken}
        setShowForm={ setShowForm }
        tradeName={store?.trade_name || ''}
      />
    )
  }

  return (
    <PaymentMethodsProvider>
      <OrganizationDetails
        setShowForm={ () => setShowForm(true) }
        tradeName={store?.trade_name || ''}
        app={store?.app || ''}
      />
    </PaymentMethodsProvider>
  );
}

export default Content;
